import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithCustomManagedStream,
} from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { buildOrderVolumeProfileConfigSlice } from 'widgets/orderVolumeProfile/store/configuration/configSlice.ts';
import { OrderVolumeProfileConfiguration } from 'widgets/orderVolumeProfile/store/configuration/OrderVolumeProfileConfiguration.ts';
import { orderVolumeProfileStreamConfig } from 'widgets/orderVolumeProfile/store/data/stream-config.ts';
import OrderVolumeProfile from 'widgets/orderVolumeProfile/components/OrderVolumeProfile.tsx';
import { orderVolumeProfileDescription } from 'widgets/orderVolumeProfile/components/help/orderVolumeProfileDescription.tsx';

const { initialConfigState } = buildOrderVolumeProfileConfigSlice();

export const orderVolumeProfileStrategy: WidgetStrategyWithConfig<OrderVolumeProfileConfiguration> &
    WidgetStrategyWithCustomManagedStream = {
    title: 'Order Volume Profile',
    supportedHosts: ['layout'],
    initialConfigState,
    reactComponentType: OrderVolumeProfile,
    description: orderVolumeProfileDescription,
    categories: [WidgetCategory.SINGLE_STOCK],
    requiredAuthorities: [],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.ExactlyOneOrder,
    managedStreamConfig: orderVolumeProfileStreamConfig,
    getRequiredOrderColumns: () => ['timeIn', 'qty'],
};
